document.addEventListener('turbolinks:load', function() {
    var submitButton = document.getElementById('submit_button');
    if (submitButton) {
      submitButton.addEventListener('click', function(event) {
        var startDate = document.getElementById('start_date').value;
        var endDate = document.getElementById('end_date').value;
        var isValid = true;
    
        // Limpa mensagens de erro anteriores
        document.getElementById('start_date_error').textContent = '';
        document.getElementById('end_date_error').textContent = '';
    
        if (!startDate) {
          document.getElementById('start_date_error').textContent = 'Data de Início é obrigatória.';
          isValid = false;
        }
    
        if (!endDate) {
          document.getElementById('end_date_error').textContent = 'Data de Término é obrigatória.';
          isValid = false;
        }
    
        // Se qualquer campo não for válido, previne o envio do formulário
        if (!isValid) {
          event.preventDefault();
        }
      });
    }
});
  